import axios from 'axios';
import { DASHBOARDAPIHOME } from './config';
import DealerDataDef from '../sections/dealer/dealerdatadef';

class DashboardService {

    constructor() {
        this.GetColumns = (menuName) => (DealerDataDef(menuName));

        this.GetGroups = (distributorId) => (axios.post(`${DASHBOARDAPIHOME}getgroups`, { distributorId }));

        this.GetAllGroups = () => (axios.post(`${DASHBOARDAPIHOME}getallgroups`));

        this.GetFranchiseByGroup = (payload) => (axios.post(`${DASHBOARDAPIHOME}getfranchisebygroup`, payload));

        this.GetDashboardParameters = (payload) => (axios.post(`${DASHBOARDAPIHOME}getdashboardparameters`, payload));

        this.GetTop10Products = (payload) => (axios.post(`${DASHBOARDAPIHOME}gettop10products`, payload));

        this.GetTop10Customers = (payload) => (axios.post(`${DASHBOARDAPIHOME}gettop10customers`, payload));

        this.GetDashboardParameterDetails = (payload) => (axios.post(`${DASHBOARDAPIHOME}getdashboardparameterdetails`, payload));

        this.GetAllProducts = (payload) => (axios.post(`${DASHBOARDAPIHOME}getallproducts`, payload));

        this.GetAllCustomers = (payload) => (axios.post(`${DASHBOARDAPIHOME}getallcustomers`, payload));

        this.GetDealerRating = (distributorCode) => (axios.post(`${DASHBOARDAPIHOME}getdealerrating`, { distributorCode }));

        this.GetDealerAgreementExpiry = (distributorCode) => (axios.post(`${DASHBOARDAPIHOME}getdealeragreementexpiry`, { distributorCode }));

        this.GetDistributorByFranchise = () => (axios.post(`${DASHBOARDAPIHOME}getdistributorbyfranchise`));

        this.GetDealerRatingAndAgreementExpiry = (payload) => (axios.post(`${DASHBOARDAPIHOME}getdealerratingandagreementexpiry`, payload));

        this.GetFranchiseByWWId = (wwid) => (axios.post(`${DASHBOARDAPIHOME}getfranchisebywwid`, { wwid }));

        this.GetDistributorByTerritory = (payload) => (axios.post(`${DASHBOARDAPIHOME}getdistributorbyterritory`, payload));

        this.GetDistributorByTerriUploadTrack = (payload) => (axios.post(`${DASHBOARDAPIHOME}getdistributorbyterriuploadtrack`, payload));

    }
}
export default new DashboardService();